import { createAction } from "redux-actions";
import { KioskConstant } from "./kioskConstant";

export const checkPrinterMode = createAction(KioskConstant.CHECK_PRINTER_MODE);
export const kioskTranslate = createAction(KioskConstant.KIOSK_TRANSLATE);
